import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_GESCON_SEF_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterTodas(filtro) {
        return axiosJwt
            .get(
                `${api}/gescon/aprovadores/requisicoes?processo=${filtro.processo ? filtro.processo : ''
                }&contrato=${filtro.contrato ? filtro.contrato : ''
                }&fornecedor=${filtro.fornecedor ? filtro.fornecedor : ''
                }&solicitante=${filtro.solicitante ? filtro.solicitante : ''
                }&dataRequisicaoDe=${filtro.dataRequisicaoDe ? filtro.dataRequisicaoDe : ''
                }&dataRequisicaoAte=${filtro.dataRequisicaoAte ? filtro.dataRequisicaoAte : ''
                }&situacao=${filtro.situacao ? filtro.situacao : ''
                }&situacaoSolicitacao=${filtro.situacaoSolicitacao}`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterOpcoesFiltros() {
        return axiosJwt
            .get(`${api}/gescon/aprovadores/requisicoes/opcoesfiltros`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterPorId(idRequisicao) {
        return axiosJwt
            .get(`${api}/gescon/aprovadores/requisicoes/${idRequisicao}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterComprometimento(idRequisicao, idComprometimento) {
        return axiosJwt
            .get(
                `${api}/gescon/aprovadores/requisicoes/${idRequisicao}/comprometimentos/${idComprometimento}`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
}
